import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, signal } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { AoFilterHeaderField, AoFilterHeaderSelect } from '../ao-filter-list-header.component';
import { debounceTime, Subject, takeUntil } from 'rxjs';

/**
 * Component for columns with distinct values that can be filtered by one value at a time.
 * The popup menu has a select for selecting which value should be filtered.
 * It also allows changing the sorting order and clearing the filter.
 */
@Component({
    selector: 'app-filter-select',
    templateUrl: './filter-select.component.html',
    styleUrls: ['./filter-select.component.scss'],
    standalone: false,
})
export class FilterSelectComponent implements OnInit, OnDestroy {
    /**
     * The field for which this filter is used
     */
    @Input() field!: AoFilterHeaderField;
    /**
     * The form control for the filter input
     */
    @Input() control!: UntypedFormControl;

    private _filter!: any;
    get filter(): any {
        return this._filter;
    }
    /**
     * The filter value object
     */
    @Input() set filter(value: any) {
        this._filter = value;
        this.setValues();
    }

    private _selectValues?: AoFilterHeaderSelect[] | undefined;
    get selectValues(): AoFilterHeaderSelect[] | undefined {
        return this._selectValues;
    }
    /**
     * The values for the multi select
     */
    @Input() set selectValues(value: AoFilterHeaderSelect[] | undefined) {
        this._selectValues = value;

        if (this.selectValues?.length) {
            this.setValues();
        }
    }

    /**
     * Emitted when the sorting order changed
     */
    @Output() sortChange = new EventEmitter<void>();

    public valueText = signal('');

    private readonly destroy = new Subject<void>();

    ngOnInit(): void {
        this.control.valueChanges.pipe(takeUntil(this.destroy), debounceTime(500)).subscribe((v) => {
            this.valueText.set(this.selectValues?.find((o) => o.value === v)?.name || '');
        });

        this.setValues();
    }

    ngOnDestroy(): void {
        this.destroy.next();
        this.destroy.complete();
    }

    private setValues(): void {
        if (this.control.value?.length) {
            if (this.control.value === 'true') {
                this.control.setValue(true, { emitEvent: false });
            } else if (this.control.value === 'false') {
                this.control.setValue(false, { emitEvent: false });
            }
        }

        this.valueText.set(this.selectValues?.find((o) => o.value === this.control.value)?.name || '');
    }

    clear(): void {
        this.control.reset();
    }
}
